import PaymentSuccessful from "./PaymentSuccessful";

export default PaymentSuccessful;
